import request from "../util/request";
import SERVER_URL from "../util/seaver";
import { exportsFile } from "../util/exports";
function processSum(reqData) {
  const reqUrl =
    SERVER_URL +
    "/workRecord/processSum"
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function salarySel(reqData) {
  const reqUrl =
    SERVER_URL + "/salary/sel";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}

function workRecordAdd(reqData) {
  const reqUrl =
    SERVER_URL + "/workRecord/add";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function workRecordMod(reqData) {
  const reqUrl =
    SERVER_URL + "/workRecord/mod";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function workRecordDel(reqData) {
  const reqUrl =
    SERVER_URL + "/workRecord/del";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function workRecordSel(reqData) {
  const reqUrl =
    SERVER_URL + "/workRecord/sel";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}

function workRecordselSum(reqData) {
  const reqUrl =
    SERVER_URL + "/workRecord/selSum";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}

function workRecordSelUserWorkSta(reqData) {
  const reqUrl =
    SERVER_URL + "/workRecord/selUserWorkSta";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}


function salaryExport(reqData, name) {
  const reqUrl =
    SERVER_URL + "/salary/export?token=" + localStorage.getItem("token");
  exportsFile(reqUrl, reqData, name)
}
function workRecordExport(reqData, name) {
  const reqUrl =
    SERVER_URL + "/workRecord/export?token=" + localStorage.getItem("token");
  exportsFile(reqUrl, reqData, name)
}

function workRecordExportBatchWork(reqData, name) {
  const reqUrl =
    SERVER_URL + "/workRecord/exportBatchWork?token=" + localStorage.getItem("token");
  exportsFile(reqUrl, reqData, name)
}

function workRecordExpUserWorkSta(reqData, name) {
  const reqUrl =
    SERVER_URL + "/workRecord/expUserWorkSta?token=" + localStorage.getItem("token");
  exportsFile(reqUrl, reqData, name)
}
export { processSum, salarySel, workRecordAdd, workRecordMod, workRecordDel, workRecordSel, workRecordselSum, workRecordSelUserWorkSta,salaryExport, workRecordExport ,workRecordExportBatchWork,workRecordExpUserWorkSta};
